// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TimeSelector.module.css */
.TimeSelector_container__43Q5n {
   
    width: 100%;
    max-width: 800px;
    height: 100vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: Arial, sans-serif;
}

.TimeSelector_title__4n7mN {
    font-size: 1.5rem; /* Aumenta el tamaño de la fuente del título */
    color: #555;
    margin-bottom: 1.5rem;
}

.TimeSelector_grid__ySnnB {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* Mantiene 4 columnas */
    gap: 15px; /* Aumenta el espacio entre los elementos */
    max-width: 400px; /* Aumenta el ancho máximo */
    margin: 0 auto;
}

.TimeSelector_time__5HOFc {
    padding: 15px; /* Aumenta el espacio interior de cada elemento */
    font-size: 1.2rem; /* Aumenta el tamaño de la fuente de cada hora */
    color: #777;
    background-color: #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.TimeSelector_time__5HOFc:hover {
    background-color: #e0e0e0;
}

.TimeSelector_selected__foI3W {
    background-color: #9db4c0;
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home/TimeSelector.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;;IAEI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB,EAAE,8CAA8C;IACjE,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC,EAAE,wBAAwB;IAC/D,SAAS,EAAE,2CAA2C;IACtD,gBAAgB,EAAE,4BAA4B;IAC9C,cAAc;AAClB;;AAEA;IACI,aAAa,EAAE,iDAAiD;IAChE,iBAAiB,EAAE,gDAAgD;IACnE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":["/* TimeSelector.module.css */\n.container {\n   \n    width: 100%;\n    max-width: 800px;\n    height: 100vh;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-family: Arial, sans-serif;\n}\n\n.title {\n    font-size: 1.5rem; /* Aumenta el tamaño de la fuente del título */\n    color: #555;\n    margin-bottom: 1.5rem;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr); /* Mantiene 4 columnas */\n    gap: 15px; /* Aumenta el espacio entre los elementos */\n    max-width: 400px; /* Aumenta el ancho máximo */\n    margin: 0 auto;\n}\n\n.time {\n    padding: 15px; /* Aumenta el espacio interior de cada elemento */\n    font-size: 1.2rem; /* Aumenta el tamaño de la fuente de cada hora */\n    color: #777;\n    background-color: #f0f0f0;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.time:hover {\n    background-color: #e0e0e0;\n}\n\n.selected {\n    background-color: #9db4c0;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TimeSelector_container__43Q5n`,
	"title": `TimeSelector_title__4n7mN`,
	"grid": `TimeSelector_grid__ySnnB`,
	"time": `TimeSelector_time__5HOFc`,
	"selected": `TimeSelector_selected__foI3W`
};
export default ___CSS_LOADER_EXPORT___;
